// These are public client identifiers, not client secrets. Keep Calendar separate.
//
// D-474 — clients of the dedicated identity project `nosubject-identity` (736604247708).
// The previous values belonged to `nosubject` (534149427803) and are shared, at project level,
// with the Calendar grants; that project-level sharing is the reason a separate project exists
// (D-458). The old clients still exist there and must not be deleted or reused here.
//
// Android is deliberately absent: its client needs the signing certificate SHA-1, which could
// not be retrieved from this environment, so it was deferred (D-472). Adding it later means one
// Console client and one key here — nothing else. An Android entry carrying the *old* project's
// ID would be worse than no entry: it would silently present a client from the wrong project.
export const GOOGLE_SIGN_IN_CLIENTS = {
  web: '736604247708-c6mo6cc8bqevnmslgkl88as2g3du53h3.apps.googleusercontent.com',
  ios: '736604247708-kv2v42he7vbob5dorcauc357ul1e8lso.apps.googleusercontent.com',
} as const;
